import React, { useState } from 'react'
import { router } from '@inertiajs/react'
import { toast } from 'sonner'
import { Lock } from 'lucide-react'
import DashboardLayout from '../../layouts/DashboardLayout'

// Owner PIN gate for LAN / shared-password mode (no per-user roles to derive ownership from).
export default function Unlock({ pin_configured }) {
  const [pin, setPin] = useState('')
  const [busy, setBusy] = useState(false)
  function submit(e) {
    e.preventDefault()
    setBusy(true)
    router.post('/stock/unlock', { pin }, { onError: () => { toast.error('Incorrect PIN'); setBusy(false) } })
  }
  return (
    <DashboardLayout>
      <div className="mx-auto mt-10 max-w-sm rounded-2xl border border-brand-border bg-white p-6 text-center">
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-brand-surface"><Lock className="text-brand-primary" /></div>
        <h1 className="text-lg font-semibold text-brand-ink">Owner PIN</h1>
        <p className="mt-1 text-sm text-brand-muted">Managing the catalogue and approving items is owner-only.</p>
        {pin_configured ? (
          <form onSubmit={submit} className="mt-5 space-y-3">
            <input type="password" inputMode="numeric" autoFocus value={pin} onChange={(e) => setPin(e.target.value)} placeholder="Enter owner PIN"
              className="w-full rounded-xl border border-brand-border bg-white px-3 py-3 text-center text-lg tracking-widest focus:border-brand-primary focus:outline-none" />
            <button type="submit" disabled={busy} className="w-full rounded-xl bg-brand-primary py-3 text-sm font-semibold text-white disabled:opacity-60">{busy ? 'Unlocking…' : 'Unlock'}</button>
          </form>
        ) : (
          <p className="mt-5 rounded-xl bg-amber-50 px-4 py-3 text-sm text-amber-800">No owner PIN is configured. Set <code>STOCK_ADMIN_PIN</code> on the server to enable owner screens.</p>
        )}
      </div>
    </DashboardLayout>
  )
}
